// @ts-expect-error: @rails/request.js is not typed
import { FetchRequest } from '@rails/request.js'
import { useState } from 'react'

import { Button } from 'slab'
import { useWindowLocation } from 'utils/windowLocation'

import { getFormattedDate } from '../utils'

const SelectCoverages = ({
  qleId,
  pendingParticipants,
  enrollments,
  backRoute,
}: {
  qleId: string
  pendingParticipants: any
  enrollments: any
  backRoute: string
}) => {
  const { assign, replace } = useWindowLocation()

  const [selectedEnrollments, setSelectedEnrollments] = useState<{
    [participantId: string]: string[]
  }>({})
  const [error, setError] = useState<string | null>(null)

  const handleClick = (participantId: string, enrollmentId: string) => {
    setSelectedEnrollments((prevSelectedEnrollments) => {
      const participantEnrollments =
        prevSelectedEnrollments[participantId] || []
      if (participantEnrollments.includes(enrollmentId)) {
        return {
          ...prevSelectedEnrollments,
          [participantId]: participantEnrollments.filter(
            (id) => id !== enrollmentId
          ),
        }
      } else {
        return {
          ...prevSelectedEnrollments,
          [participantId]: [...participantEnrollments, enrollmentId],
        }
      }
    })
  }

  const formatBirthdate = (dob: string) => {
    return getFormattedDate(dob, { timeZone: 'UTC' })
  }

  const capitalizeFirstLetter = (word: string) => {
    return word.charAt(0).toUpperCase() + word.slice(1)
  }

  const handleSubmit = async () => {
    try {
      // TODO: this method of making an API call is deprecated -- please use reactquery instead
      // see https://www.notion.so/thatchhealth/Using-React-Query-for-Fetching-Data-160114874bc280379918d43442405589
      const request = new FetchRequest(
        'post',
        `/api/qualifying_life_events/${qleId}/coverages`,
        {
          body: JSON.stringify(selectedEnrollments),
        }
      )

      const response = await request.perform()
      const data = await response.json

      if (response.ok) {
        assign(data.redirect_to)
      }
    } catch (error: any) {
      setError(error.message)
    }
  }

  return (
    <>
      <div className='flex flex-col space-y-8 max-w-2xl items-center justify-between'>
        {pendingParticipants.map((participant: any) => (
          <div
            className='flex flex-wrap gap-4 w-full items-center justify-between'
            key={participant.id}
          >
            <div>
              <div className='text-xl mb-1'>
                {participant.given_name} {participant.family_name}
              </div>
              <div className='flex flex-wrap items-center gap-2 text-thatch-gray-secondary text-sm'>
                <div>{capitalizeFirstLetter(participant.relationship)}</div>
                <div>/</div>
                <div>{capitalizeFirstLetter(participant.gender)}</div>
                <div>/</div>
                <div>{formatBirthdate(participant.dob)}</div>
              </div>
            </div>
            <div className='flex flex-wrap gap-4 items-center justify-center'>
              {enrollments.map((enrollment: any) => (
                <div
                  key={enrollment.id}
                  onClick={() =>
                    handleClick(participant.id, enrollment.coverage_type)}
                  style={
                    enrollment.logo_url
                      ? {
                          backgroundImage: `url("${enrollment.logo_url}")`,
                          backgroundSize: '100px',
                        }
                      : {}
                  }
                  className={`shadow-md hover:border-thatch-purple-secondary bg-center bg-no-repeat w-32 h-16 border rounded-lg flex items-center justify-center text-gray-700 text-sm cursor-pointer ${
                    selectedEnrollments[participant.id]?.includes(
                      enrollment.coverage_type
                    )
                      ? 'border-thatch-purple-secondary border-2'
                      : 'border-gray-300'
                  }`}
                  data-testid={`${enrollment.coverage_type}-coverage`}
                >
                  {!enrollment.logo_url && enrollment.coverage_type}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className='pt-6 flex justify-between'>
        <Button
          onClick={() => replace(backRoute)}
          data-testid='button-back'
        >
          Back
        </Button>
        <Button onClick={handleSubmit} variant='primary'>
          Next
        </Button>
      </div>
      {error && (
        <div className='bg-red-100 text-red-500 mt-4 p-2 rounded-lg text-center'>
          {error}
        </div>
      )}
    </>
  )
}

export default SelectCoverages
